import { useEffect, useState } from 'react';

/**
 * SC-966 — a clock that re-renders its caller every `intervalMs` while
 * `active`. The « Résas » tab re-filters against it so a booking leaves the
 * list when its grace window ends, not when the next poll happens to land.
 */
export function useNow(intervalMs: number, active = true): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!active) return undefined;
    setNow(Date.now());
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs, active]);
  return now;
}
